export const FONT_SIZE_PREFERENCES = Object.freeze({
  MAIS_ESPACO: "MAIS_ESPACO",
  PADRAO: "PADRAO",
  TEXTO_MAIOR: "TEXTO_MAIOR",
});

const DEFAULT_FONT_SIZE_PREFERENCE = FONT_SIZE_PREFERENCES.MAIS_ESPACO;
const ROOT_CLASSES = Object.freeze({
  [FONT_SIZE_PREFERENCES.MAIS_ESPACO]: "cajupe-font-size--mais-espaco",
  [FONT_SIZE_PREFERENCES.PADRAO]: "cajupe-font-size--padrao",
  [FONT_SIZE_PREFERENCES.TEXTO_MAIOR]: "cajupe-font-size--texto-maior",
});

export function normalizeFontSizePreference(value) {
  return Object.prototype.hasOwnProperty.call(ROOT_CLASSES, value)
    ? value
    : DEFAULT_FONT_SIZE_PREFERENCE;
}

export function applyFontSizePreference(value) {
  const preference = normalizeFontSizePreference(value);
  if (typeof document === "undefined" || !document.documentElement) {
    return preference;
  }

  const root = document.documentElement;
  Object.values(ROOT_CLASSES).forEach((className) => {
    root.classList.remove(className);
  });
  root.classList.add(ROOT_CLASSES[preference]);
  root.dataset.fontSizePreference = preference;

  return preference;
}
